import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { DropdownMenuItem } from '@c2fo/liquidity';
import { UserGearIcon } from '@c2fo/liquidity/icons';
import { asEnterpriseLink } from '@/utils/experienceLinkHelper';
import UserAvatar from './UserAvatar';

interface UserInfoSectionProps {
  initials: string;
  accountName: string;
  name: string;
  variant: 'desktop' | 'mobile';
  onSettingsClick?: () => void;
}

const UserInfoSection = ({ initials, accountName, name, variant, onSettingsClick }: UserInfoSectionProps) => {
  const { t } = useTranslation();

  const accountSettingsLink = asEnterpriseLink('account/settings');

  if (variant === 'desktop') {
    return (
      <div className="flex gap-4 p-4">
        <UserAvatar initials={initials} size="lg" />
        <div>
          {accountName && <div className="font-bold">{accountName}</div>}
          {name && <div className="text-sm text-text-secondary">{name}</div>}
          <DropdownMenuItem asChild className="p-0 text-blue-500 hover:bg-transparent focus:bg-transparent">
            <Link className="flex items-center gap-1 pt-1 text-sm font-bold text-blue-500" to={accountSettingsLink}>
              <UserGearIcon className="size-5 shrink-0 fill-blue-500" />
              {t('core.accountSettings')}
            </Link>
          </DropdownMenuItem>
        </div>
      </div>
    );
  }

  return (
    <div className="flex gap-4 px-4 py-6">
      <UserAvatar initials={initials} size="lg" />
      <div className="mr-8 min-w-0 flex-1">
        {accountName && <div className="break-words font-bold">{accountName}</div>}
        {name && <div className="break-words text-sm text-text-secondary">{name}</div>}
        <Link
          className="flex items-center gap-1 break-words pt-1 text-sm font-bold text-blue-500"
          onClick={onSettingsClick}
          to={accountSettingsLink}
        >
          <UserGearIcon className="size-5 shrink-0 fill-blue-500" />
          {t('core.accountSettings')}
        </Link>
      </div>
    </div>
  );
};

export default UserInfoSection;
